import { IColumn } from '../types';
import { defaultHeaderRenderer } from '../headers';
import { RightAlign } from '../styles';
import { hasPerm, P } from '../../../../../utilities/roles/permissions';
import { CellEventsHandler } from '../formatters';
import { CellProps } from '../../types';
import { getDaysInCurrentStage } from '../../../../../utilities/stages/getDaysInTheCurrentStage';

const CenterAlignFormatter = (cellProps: CellProps) => {
  const daysCount = Number(getDaysInCurrentStage(cellProps.row));
  const text = daysCount === 0 ? 'less than a day' : daysCount === 1 ? `${daysCount} day` : `${daysCount} days`;
  return (
    <CellEventsHandler cellProps={cellProps}>
      <RightAlign>{text}</RightAlign>
    </CellEventsHandler>
  );
};

export const DaysInStageColumn = (): IColumn => ({
  item: {
    key: 'casStatusUpdatedAt',
    name: 'Days in stage',
    headerRenderer: defaultHeaderRenderer,
    sortable: true,
    width: 'minmax(96px, .75fr)',
    formatter: CenterAlignFormatter,
  },
  visible: ({ role }) => hasPerm(role, P.DAYS_IN_STAGE),
});
